import * as api from '../../services/ibeaconConfig'

export const FETCH_IBEACONS = 'FETCH_IBEACONS';



/*
export const fetchIbeacon = (id) => {
    return {
        type: FETCH_IBEACON,
        payload: {
            promise: api.findIbeacon({id: id})
        }
    }
}
*/


export const fetchIbeacons = (params, pagination, sort, extra) => {
    return {
        type: FETCH_IBEACONS,
        payload: {
            promise: api.findIbeacons(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/ibeanconConfig.js